import { render, staticRenderFns } from "./TableInfo.vue?vue&type=template&id=4b9aa215&"
import script from "./TableInfo.vue?vue&type=script&lang=ts&"
export * from "./TableInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TableInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports